// @ts-nocheck
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import "./AddCNPickupUpdation.scss";
import { CNPickupUpdationConfig } from "./AddCNPickupUpdationConfig";
import MemoMainComponent from "../../LRTable/MemoMainComponent";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import {
  CREATE_PICKUP_UPDATION_MEMO,
  EDIT_PICKUP_UPDATION,
  GET_LOAD_RECEIPT,
  getFormSectionsAndFields,
  GetPickupUpdationDataByID,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";
import { useDispatch } from "react-redux";
import { useModalContext } from "../../Reactportal/ModalContext";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import {
  ClearFields,
  handleFormReset,
  updateSingleField,
  updateValueForm,
} from "../../FormInputSectionComponent/formUtils";
import { useRecoilState } from "recoil";
import { AtomFormState } from "../../../../atoms/FormAtom";

const AddCNPickupUpdation = ({
  show,
  id,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  openByCard,
  FormDetailsByCard,
  openByCardId
}) => {
  const Form_Key = "CN_Pickup_Updation";
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Pickup Updation");
  const [LRData, setLRData] = useState<any[]>([]);
  const [toggle, settoggle] = useState(show ? show : false);
  const [LRList, setLRList] = useState<any[]>([]);
  const [LRData1, setLRData1] = useState<any[]>([]);
  const [currentBranch, setCurrentBranch] = useState("");
  const [FormValue, setFormValue] = useRecoilState(AtomFormState(Form_Key));
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);
  const fielddataRedux = useSelector((store: any) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.CN_Pickup_Updation?.Selected_Row;
  const dispatch = useDispatch();
  const [createdMemo, setCreatedMemo] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const formRef = useRef({});
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [InputFields, setInputFields] = useState([]);
  const [FormData, setFormdata] = useState<any>({});
  const { pushModal, popModal } = useModalContext();
  const [allFieldsData, setAllFieldsData] = useState<any>({});
  const [CreatePickupMemoUpdation, { loading: AddLoading, error, data }] = useMutation(CREATE_PICKUP_UPDATION_MEMO, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
  });
  const [EditPickupMemoUpdation, { loading: EditLoading }] = useMutation(EDIT_PICKUP_UPDATION, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
  });
  const [getFormSectionAndFields, { loading: getFormSectionAndFieldsLoading }] = useLazyQuery(
    getFormSectionsAndFields,
    {
      variables: {
        key: Form_Key,
      },
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setInputFields(data?.formSectionAndFields);
      },
    }
  );
  const [GetMemoById, { loading: getLoading, data: memoData }] = useLazyQuery(GetPickupUpdationDataByID, {
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    fetchPolicy: "no-cache",
  });
  const LoadingState = AddLoading || EditLoading || getLoading ? true : false;

  useEffect(() => {
    getFormSectionAndFields();
  }, []);

  useEffect(() => {
    if (FormData?.Mode && isFirstLoad) {
      setFormValue({ Mode: FormData?.Mode });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Vehicle_No: {},
          },
        },
      });
      updateSingleField(formRef, "Vehicle_No", "");
    }
  }, [FormData?.Mode]);


  useEffect(() => {
    if (TypeOfPortal == "Edit" && InputFields?.length) {
      const inputNames = ["PickupMemo_Id"];

      inputNames.forEach((name) => {
        const input = document.getElementsByName(name);
        if (input.length > 0) {
          const lastInput = input[input.length - 1] as HTMLInputElement;
          lastInput.disabled = true;
        }
      });
    }
  }, [InputFields]);

  useEffect(() => {
    if (
      TypeOfPortal == "Add" &&
      FormDataFromRedux &&
      FormDataFromRedux?.MasterData[Form_Key]?.PickupMemo_Id?.RemainingCNData
    ) {
      setCreatedMemo(true);
      setTimeout(() => {
        setCreatedMemo(false);
      }, 100);
      setLRList(ConvertDateValues(FormDataFromRedux?.MasterData[Form_Key]?.PickupMemo_Id?.RemainingCNData));
    } else if (TypeOfPortal == "Add") {
      setLRList([]);
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.PickupMemo_Id]);

  useEffect(() => {
    const value = FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code;
    if (TypeOfPortal === "Add" && value && currentBranch && currentBranch?._id !== value?._id && !openByCard) {
      ClearSpecificForm(dispatch, Form_Key);
      ClearFields(formRef);
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Branch_Code: value,
          },
        },
      });
    }
    setCurrentBranch(value);
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Branch_Code]);

  useEffect(() => {
    if (FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name) {
      let obj = FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name;
      updateSingleField(formRef, "Driver_No", obj?.Mobile_Number);
    }
  }, [FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.CN_Pickup_Updation?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (LRData.length === 0) {
      return WarningToast("Please Select at Least 1 Lr");
    } else if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (InputFields.length) {
      if (TypeOfPortal !== "Add") {
        GetMemoById({
          variables: {
            id: openByCard ? openByCardId : fielddata?._id,
          },
        }).then(({ data }) => {
          let MemoData = { ...data?.getAllCNPickupUpdationsByID_WithPopulate };
          delete MemoData.__typename;

          let lr1 = ConvertDateValues(MemoData?.Consignment_Note_Data);
          let lr2 = ConvertDateValues(MemoData?.RemainingCNData);

          setLRList((prev) => [...lr1, ...lr2]);
          setLRData1(ConvertDateValues(MemoData?.Consignment_Note_Data));
          MemoData.Vehicle_No = MemoData?.Vehicle_No_Data?.Search_Value;
          MemoData.Driver_Name = MemoData?.Driver_Name_Data?.Name;
          MemoData.Date = IsoToDateWithoutTime(MemoData.Date);
          MemoData.PickupMemo_Id = MemoData?.PickupMemo_Data?.Search_Value;
          updateValueForm(formRef, MemoData);
          setAllFieldsData(MemoData);

          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                Driver_Name: MemoData?.Driver_Name_Data,
                Vehicle_No: MemoData?.Vehicle_Data,
                PickupMemo_Id: MemoData?.PickupMemo_Data,
                Branch_Code: MemoData?.Branch_Code_Data,
              },
            },
          });
        });
      } else {
        if (openByCard) {
          // console.log(FormDetailsByCard, "FormDetailsByCardFormDetailsByCard");
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: Form_Key,
              data: {
                PickupMemo_Id: {
                  _id: FormDetailsByCard?.PickupMemo_Data?._id,
                  Unique_Id: FormDetailsByCard?.PickupMemo_Data?.Unique_Id,
                  Search_Value: FormDetailsByCard?.PickupMemo_Data?.PRS_NO,
                },
                Vehicle_No: {
                  _id: FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?._id,
                  Search_Value: FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.RC_Number,
                },
                Driver_Name: {
                  _id: FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?._id,
                  Search_Value: FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Name,
                  Mobile_Number: FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Mobile_Number,
                },
                Branch_Code: FormDetailsByCard?.PickupMemo_Data?.Branch_Code_Data,
              },
            },
          });
          updateSingleField(formRef, "Date", GetTodaysDateINdmy());
          updateSingleField(formRef, "Branch_Code", FormDetailsByCard?.PickupMemo_Data?.Branch_Code_Data?.Search_Value);
          updateSingleField(formRef, "PickupMemo_Id", FormDetailsByCard?.PickupMemo_Data?.PRS_NO);

          if (FormDetailsByCard?.PickupMemo_Data?.Mode == "Truck") {
            updateSingleField(
              formRef,
              "Vehicle_No",
              FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.RC_Number
            );
          } else {
            updateSingleField(
              formRef,
              "Vehicle_No",
              FormDetailsByCard?.PickupMemo_Data?.Vehicle_Data?.Vehicle_No
            );
          }

          updateSingleField(formRef, "Driver_Name", FormDetailsByCard?.PickupMemo_Data?.Driver_Name_Data?.Name);
          updateSingleField(formRef, "Mode", FormDetailsByCard?.PickupMemo_Data?.Mode);
          setLRData1(ConvertDateValues(FormDetailsByCard?.LR_Data));
        } else {
          updateSingleField(formRef, "Date", GetTodaysDateINdmy());
          updateSingleField(formRef, "Mode", "Truck");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddata, InputFields]);

  const submit = async (close) => {
    const idArray = LRData.map((item: any) => item._id);
    let data: any = FormData;
    data.Consignment_Note_Ids = idArray;
    data.Date = data.Date ? convertToISO(data?.Date) : null;
    data.Vehicle_No = FormDataFromRedux.MasterData[Form_Key]?.Vehicle_No?._id;
    data.Driver_Name = FormDataFromRedux?.MasterData[Form_Key]?.Driver_Name?._id;
    data.Driver_No = String(FormData?.Driver_No);
    data.PickupMemo_Id = FormDataFromRedux?.MasterData[Form_Key]?.PickupMemo_Id?._id;

    if (TypeOfPortal.includes("Edit")) {
      await EditPickupMemoUpdation({
        variables: { id: openByCard ? openByCardId : fielddata?._id, userInput: data },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Pickup Updation Edited Successfully");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await CreatePickupMemoUpdation({
        variables: {
          createInput: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Pickup Updation Created Successfully");
          ClearSpecificForm(dispatch, Form_Key);
          handleFormReset(formRef);

          setCreatedMemo(true);
          setTimeout(() => {
            setCreatedMemo(false);
          }, 100);
          if (close === "close") {
            Closeformfunction();
          }
          setLRList(prev => [])
          updateValueForm(formRef, {
            Date: GetTodaysDateINdmy(),
            Mode: "Truck",
          });
        })
        .catch((err) => {
          ErrorToast("Something went wrong! Please Check fields and try again.");
        });
    }
  };

  const Closeformfunction = () => {
    ClearSpecificForm(dispatch, Form_Key);
    handleFormReset(formRef);
    settoggle(false);
    ParentPortalCloseFunction();
  };

  return (
    <Reactportal
      open={toggle}
      onClose={Closeformfunction}
      TypeOfPortal={modifiedTypeOfPortal}
      ShowBranchInput={true}
      Form_Key={Form_Key}
    >
      <div className="lr-updation-modal-container">
        <div className="horizontalcontainer">
          {InputFields &&
            InputFields.map((e) => {
              return (
                <div key={e.id} className="">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="horizantalSection insidecontainer">
                    <FormInputSectionComponent
                      inputfields={e.fields}
                      Type={e.name}
                      onhandleFormikChange={HanldeChangeonForm}
                      validation_Schema={e?.Valid_schema}
                      onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                      formkey={Form_Key}
                      formRef={formRef}
                      TypeOfPortal={TypeOfPortal}
                      setFirstLoad={setFirstLoad}
                    />
                  </div>
                </div>
              );
            })}
        </div>
        <div className="InwardLRTable">
          {/* {LRList?.length ? ( */}
          <MemoMainComponent
            TypeofPortal={`CN Pickup Updation ${TypeOfPortal}`}
            data={LRList}
            fielddata={""}
            totalWeight={(val: number) => { }}
            setLR={(val) => setLRData(val)}
            createdMemo={createdMemo}
            SelectedData={LRData1}
            formkey={Form_Key}
            openByCard={openByCard}
          />
          {/* ) : (
                ""
              )} */}
        </div>
      </div>
      <PortalFooter
        renderContent={() => <></>}
        disabled={false}
        submitType={submitType}
        loadingState={LoadingState}
        Form_key={Form_Key}
        TypeOfPortal={TypeOfPortal}
        submitform={() => {
          Validate_handleSubmit(submit);
        }}
        SaveAndClose={() => {
          Validate_handleSubmit(() => {
            submit("close");
          });
        }}
        handleformclose={() => {
          // settoggle(!toggle);
          Closeformfunction();
        }}
      />
    </Reactportal>
  );
};

export default AddCNPickupUpdation;
